import TaxProfileSummary from './TaxProfileSummary';

export default TaxProfileSummary;
